(ns frontend.ux-overhaul.listing.indirect-holding.view
  (:require [common.localization :as loc]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [frontend.ux-overhaul.listing.indirect-holding.event :as indirect-holding-event]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "indirect-holding-listing")

(defn- open-row!
  [value]
  (rf/dispatch [::indirect-holding-event/open-holding-target value]))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/calculated-indirect-holding
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :indirect-holding
                                :load-facets-event [::generic-facets-event/load-facets]}
         ;; No kanban/gallery - there is no single natural title/image for a
         ;; fund/holding pair (see common.schema.entities.calculated.indirect-holding.core,
         ;; no :result/title-attr), and this is a read-only computed listing
         ;; with nothing to create, so no toolbar actions either.
         :available-view-modes #{:grid :list}
         :toolbar-actions      []}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [listing/view
       {:listing-id               listing-id
        :title                    (loc/tr :indirect-holdings)
        :show-view-mode-selector? true
        :query-placeholder        (loc/tr :listing.indirect-holding/search-placeholder)
        :on-row-clicked           open-row!
        :on-card-clicked          open-row!}])}))
